import {
  ACT_COUNTRIES_FETCH_INIT,
  ACT_COUNTRIES_FETCH_200,
  ACT_COUNTRIES_ADD_INIT,
  ACT_COUNTRIES_ADD_201,
  ACT_COUNTRIES_DELETE_INIT,
  ACT_COUNTRIES_DELETE_204,
  ACT_COUNTRIES_ADD_500,
} from '../constants/actions';

const defaultState = {
  isLoadingCountries: false,
  didLoadCountries: false,
  isAddingCountry: false,
  didSuccessfullyAddCountry: false,
  addCountryError: undefined,
  isDeletingCountry: false,
  countriesList: [],
};

const countriesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_COUNTRIES_FETCH_INIT:
      return {
        ...state,
        isLoadingCountries: true,
        didLoadCountries: false,
        didSuccessfullyAddCountry: false,
        countriesList: [],
      };
    case ACT_COUNTRIES_FETCH_200:
      return {
        ...state,
        isLoadingCountries: false,
        didLoadCountries: true,
        countriesList: action.payload,
      };
    case ACT_COUNTRIES_ADD_INIT:
      return {
        ...state,
        isAddingCountry: true,
        didSuccessfullyAddCountry: false,
        addCountryError: undefined,
      };
    case ACT_COUNTRIES_ADD_201:
      return {
        ...state,
        isAddingCountry: false,
        didSuccessfullyAddCountry: true,
        addCountryError: undefined,
      };
    case ACT_COUNTRIES_ADD_500:
      return {
        ...state,
        isAddingCountry: false,
        didSuccessfullyAddCountry: false,
        addCountryError: action.payload,
      };
    case ACT_COUNTRIES_DELETE_INIT:
    case ACT_COUNTRIES_DELETE_204:
    default:
      return state;
  }
};

export default countriesReducer;
